module.exports = __webpack_public_path__ + "img/beetle_leg2.7288051a.png";